import { Grid, Switch } from "@mui/material";
import { DatePickerForm } from "components";
import { useApiMutation } from "hooks/useApi/useApiHooks";
import { FC, useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { IAcademicYear } from "types/common.types";

interface IAcademicYearForm {
  formStore: UseFormReturn<IAcademicYear>;
  editingAcademicYear?: IAcademicYear;
  resetForm: () => void;
}

const AcademicYearForm: FC<IAcademicYearForm> = ({
  formStore,
  editingAcademicYear,
  resetForm,
}) => {
  const { control, handleSubmit, reset } = formStore;
  const { t } = useTranslation();

  const { mutate, status } = useApiMutation<any>(
    "/academic-year",
    editingAcademicYear ? "put" : "post"
  );

  const submit = (data: any) => {
    if (editingAcademicYear) {
      // Check if only isCurrent is changed
      if (data.isCurrent !== undefined &&
        data.startsAt === editingAcademicYear.startsAt &&
        data.endsAt === editingAcademicYear.endsAt) {
        mutate({
          _id: editingAcademicYear._id,
          isCurrent: data.isCurrent
        });
      } else {
        // Otherwise send all data
        mutate({
          ...data,
          _id: editingAcademicYear._id,
        });
      }
    } else mutate(data);
  };

  useEffect(() => {
    if (status === "success") {
      resetForm();
    }
  }, [status]);

  useEffect(() => {
    if (editingAcademicYear) {
      reset({
        startsAt: editingAcademicYear.startsAt,
        endsAt: editingAcademicYear.endsAt,
      });
    }
  }, [editingAcademicYear]);

  return (
    <form id="academic-year-add" onSubmit={handleSubmit(submit)}>
      <Grid container spacing={2} width={400}>
        <Grid item xs={12} md={12}>
          <DatePickerForm
            control={control}
            name="startsAt"
            label={t("general.startDate")!}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <DatePickerForm
            control={control}
            name="endsAt"
            label={t("general.endDate")!}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <label htmlFor="academicYear" className="flex justify-between items-center">
            <label className="theme_title">{t(`general.active`)}</label>
            <Switch type="checkbox"
              id="academicYear"
              disabled={editingAcademicYear?.isReadOnly}
              defaultChecked={editingAcademicYear?.isCurrent}
              onChange={(e) => {
                formStore.setValue("isCurrent", e.target.checked);
                formStore.trigger("isCurrent");
              }}
            />
          </label>
        </Grid>
      </Grid>
    </form>
  );
};

export default AcademicYearForm;
